/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Settings_Required_ErrorInputs */

const en_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings object is required`)
};

const fr_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objet de parametres requis`)
};

const de_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Einstellungsobjekt ist erforderlich.`)
};

const it_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'oggetto Impostazioni è obbligatorio`)
};

const ru_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объект настроек обязателен`)
};

const es_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere el objeto de configuración`)
};

const zh_cn2_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要设置对象。`)
};

const ja_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定オブジェクトが必要です`)
};

const hi_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स ऑब्जेक्ट आवश्यक है`)
};

const pt_pt2_iframe_remote_settings_required_error = /** @type {(inputs: Iframe_Remote_Settings_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O objeto de configurações é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Settings object is required" |
*
* @param {Iframe_Remote_Settings_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_settings_required_error = /** @type {((inputs?: Iframe_Remote_Settings_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Settings_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_settings_required_error(inputs)
	if (locale === "de") return de_iframe_remote_settings_required_error(inputs)
	if (locale === "it") return it_iframe_remote_settings_required_error(inputs)
	if (locale === "ru") return ru_iframe_remote_settings_required_error(inputs)
	if (locale === "es") return es_iframe_remote_settings_required_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_settings_required_error(inputs)
	if (locale === "ja") return ja_iframe_remote_settings_required_error(inputs)
	if (locale === "hi") return hi_iframe_remote_settings_required_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_settings_required_error(inputs)
	return en_iframe_remote_settings_required_error(inputs)
});